import React from 'react'
import styled from 'styled-components'
import { CustomCheckBox } from 'src/components/Global/CheckBox/Checkbox'
import { ModalButton } from 'src/components/Global/Button/Button'
import { Link, useLocation } from 'react-router-dom'
const UpdateSettings = styled.div`
  padding-top: 23px;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 88vh;
  h1 {
    font-family: ${({ theme }) => theme.fontFamily.visuelt};
    font-style: normal;
    font-weight: 500;
    font-size: ${({ theme }) => theme.fontSize.x1};
    line-height: 32px;
    color: ${({ theme }) => theme.colors.CollaboBlue};
  }
  h6 {
    font-size: ${({ theme }) => theme.fontSize.x4};
    line-height: 24px;
    letter-spacing: 0.75px;
    color: ${({ theme }) => theme.colors.gray};
    font-weight: 500;
    margin-top: -10px;
  }
  .check {
    display: flex;
    align-items: center;
    margin-top: -30px;
  }
  h4 {
    font-size: ${({ theme }) => theme.fontSize.s};
    line-height: 20px;
    color: ${({ theme }) => theme.colors.dark};
    padding-top: 10px;
  }
`
const InterestSettings = () => {
  let location = useLocation()
  return (
    <UpdateSettings>
      <div>
        <h1>Interest Settings</h1>
        <h6>You can disable or enable interest on your F&K account.</h6>
        <div className="check">
          <CustomCheckBox />
          <h4>Enable interest on savings</h4>
        </div>
      </div>
      <div>
        <Link
          to={`/security-question`}
          state={{ backgroundLocation: location }}
        >
          <ModalButton className="cancel">Update Settings</ModalButton>
        </Link>
      </div>
    </UpdateSettings>
  )
}
const NotificationSettings = () => {
  let location = useLocation()
  return (
    <UpdateSettings>
      <div>
        <h1>Notification Settings</h1>
        <h6>Be in control of the messages on your F&K Savings account.</h6>
        <div className="check">
          <CustomCheckBox />
          <h4>Disable Referral notifications</h4>
        </div>
      </div>
      <div>
        <Link
          to={`/security-question`}
          state={{ backgroundLocation: location }}
        >
          <ModalButton className="cancel">Update Settings</ModalButton>
        </Link>
      </div>
    </UpdateSettings>
  )
}
export { InterestSettings, NotificationSettings }
